export const UPDATE_THEME = "UPDATE_THEME";
export const UPDATE_LOADING = "UPDATE_LOADING";
export const UPDATE_LANGUAGE = "UPDATE_LANGUAGE";
export const UPDATE_MESSAGE = "UPDATE_MESSAGE";

export const UPDATE_TOKEN = "UPDATE_TOKEN";
export const UPDATE_USER_DATA = "UPDATE_USER_DATA";
